import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 96px 0 104px;
  background: linear-gradient(180deg, #16294a 0%, #0f2137 100%);
  color: #fff;

  @media (max-width: 990px) {
    padding: 72px 0 80px;
  }
  @media (max-width: 767px) {
    padding: 56px 0 64px;
  }
`;

export const Intro = styled.div`
  max-width: 720px;
  margin: 0 auto 48px;
  text-align: center;

  > span {
    display: block;
    margin-bottom: 8px;
    color: #fdb32a;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.15em;
  }

  h2 {
    margin: 0 0 16px;
    color: #fff;
    font-size: 34px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.03em;
  }

  p {
    margin: 0;
    color: #d3dff2;
    font-size: 17px;
    line-height: 1.7;
  }

  @media (max-width: 767px) {
    margin-bottom: 32px;
    h2 {
      font-size: 26px;
    }
    p {
      font-size: 16px;
    }
  }
`;

export const Steps = styled.ol`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  margin: 0;
  padding: 0;
  list-style: none;

  @media (max-width: 990px) {
    grid-template-columns: minmax(0, 1fr);
    max-width: 560px;
    margin: 0 auto;
  }
`;

export const Step = styled.li`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);

  .visual {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 14px;
    height: 190px;
    padding: 20px;
    background: rgba(5, 14, 28, 0.45);
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    overflow: hidden;
  }

  .body {
    padding: 22px 24px 26px;
  }

  .num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    margin-bottom: 12px;
    border-radius: 50%;
    background: #fdb32a;
    color: #0f2137;
    font-size: 15px;
    font-weight: 700;
  }

  h3 {
    margin: 0 0 8px;
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  p {
    margin: 0;
    color: #d3dff2;
    font-size: 15px;
    line-height: 1.7;
  }
`;

export const OsRow = styled.div`
  display: flex;
  gap: 10px;

  span,
  a {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
  }

  a:hover {
    border-color: rgba(255, 255, 255, 0.55);
    background: rgba(255, 255, 255, 0.16);
  }

  @media (max-width: 420px) {
    gap: 6px;
    span,
    a {
      padding: 7px 8px;
      font-size: 12px;
      gap: 6px;
    }
  }
`;

export const CodeFrame = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  background: #060f1d;
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #fff;
  font-family: 'SF Mono', SFMono-Regular, Consolas, 'Liberation Mono', Menlo,
    monospace;
  font-size: 14px;

  i {
    color: #fdb32a;
    font-style: normal;
  }
`;

export const CodeBoxes = styled.div`
  display: flex;
  gap: 8px;

  .label {
    display: block;
  }

  b {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 44px;
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    font-size: 20px;
    font-weight: 700;
  }

  b.active {
    border-color: #fdb32a;
    box-shadow: 0 0 0 2px rgba(253, 179, 42, 0.35);
  }

  @media (max-width: 420px) {
    gap: 6px;
    b {
      width: 30px;
      height: 40px;
    }
  }
`;

export const CodeLabel = styled.div`
  color: #d3dff2;
  font-size: 13px;
`;

export const ScanShot = styled.img`
  display: block;
  width: calc(100% + 40px);
  max-width: none;
  height: 190px;
  margin: -20px;
  object-fit: cover;
  object-position: left top;
`;

export const Cta = styled.div`
  margin-top: 48px;
  text-align: center;

  h3 {
    margin: 0 0 20px;
    color: #fff;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  p {
    margin: 14px 0 0;
    color: #d3dff2;
    font-size: 14px;
    line-height: 1.6;
  }

  @media (max-width: 767px) {
    margin-top: 36px;
  }
`;
